import {UI, StyleSheet, styleRule, registerStyle} from "../../../../stem-core/src/ui/UI";
import {Messages} from "../../../Messages";
import {ExternalLink} from "../../../widget/ui/ExternalLink";


class TermsMessageStyle extends StyleSheet {
    @styleRule
    element = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRule
    termsText = {
        display: "inline-block",
        maxWidth: 480,
        paddingTop: 12,
        marginTop: 4,
    };
}

@registerStyle(TermsMessageStyle)
export class TermsMessage extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            preMessage: "",
            postMessage: Messages.termsAndConditions,
            termsLink: "/terms",
            policyLink: "/privacy-policy",
        }
    };

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.options.showBorder) {
            attr.setStyle("borderTop", "0.5px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR);
        }
        attr.addClass(this.styleSheet.element);
    }

    render() {
        const {styleSheet} = this;
        const {preMessage, postMessage} = this.options;

        return [
            <div className={styleSheet.termsText} testId="termsText">
                <span>{[preMessage, postMessage]}</span>
                <ExternalLink testId="signupTermsLink" href={this.options.termsLink} newTab noIcon label={Messages.terms} />
                {" and "}
                <ExternalLink testId="signupPolicyLink" href={this.options.policyLink} newTab noIcon label={Messages.policy} />
                .
            </div>,
        ];
    }
}
